enum SkeletalDataProvider {
  TRACAB = 'tracab'
}

export default SkeletalDataProvider;
